import { createSelector } from '@reduxjs/toolkit';
export const flagsReducer = (state) => state.flags;
export const flagsDataSelector = createSelector(flagsReducer, (selector) => Object.values(selector.resources));
